<div class="page-layout carded left-sidenav toolbar-fixed-layout">
  <div class="toolbar second-level-toolbar flex flex-col justify-between items-center">
    <div class="grid-toolbar-buttons-group-container w-p-100 flex flex-col justify-center items-start">
      <particle-breadcrumbs [breadcrumbs]="breadcrumbs"></particle-breadcrumbs>
    </div>
  </div>

  <mat-sidenav-container>
    <!-- CENTER -->
    <div class="center">
      <!-- CONTENT CARD -->
      <div particleHelpNotes helpNoteId="data-survey-single-overview" class="content-card mat-white-bg">

        <mat-tab-group class="custom-mat-tab"
                       (selectedIndexChange)="onTabIndexChange($event)" [selectedIndex]="selectedTabIndex">
          <mat-tab *ngFor="let tab of tabs; let i = index" label="{{tab.header}}">
            <div *ngIf="tabs[selectedTabIndex].id == 'Templates'"
                 class="toolbar second-level-toolbar flex flex-row justify-between items-center" flex flex-col>

              <div class="grid-toolbar-buttons-group-container flex flex-col justify-center items-start">
                <label class="component-label"> Actions</label>
                <div class="grid-toolbar-buttons-group flex flex-row justify-start items-center">
                  <div *ngIf="tabs[selectedTabIndex].id == 'Templates'"
                       class="button-container flex flex-row justify-start items-center">
                    <button mat-button class="orbitax-flat-button" (click)="addTemplate()"
                            particleAnalytics
                            analyticsCategory="file-manager-content"
                            analyticsAction="Add-Folder">Add Template
                    </button>
                    <div class="toolbar-separator"></div>
                  </div>
                  <div class="button-container flex flex-row justify-start items-center">
                    <button mat-button class="orbitax-flat-button" (click)="importTemplate()"
                            particleAnalytics
                            analyticsCategory="file-manager-content"
                            analyticsAction="Add-Folder">Import Template
                    </button>
                    <div class="toolbar-separator"></div>
                  </div>
                </div>
              </div>

            </div>
            <div class="content pos-relative m-30" [id]="tabs[selectedTabIndex].id">
              <div class="keno-grid-container">
                <particle-virtual-grid [sourceKey]="tab.sourceKey"
                                       sortFieldKey="ModifiedDate"
                                       sortDirection="desc"
                                       (valueChanged)="onGridCellValueChange($event)"
                                       [invalidateSubject]="invalidateSubject">
                </particle-virtual-grid>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </mat-sidenav-container>
</div>

